import { Injectable } from '@angular/core';
import { ArrivalQcGeneration } from '@app/generated/graphql';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ArrivalQcGenerationService {
  // subjects
  private arrivalQcGenerationDataSubject =
    new BehaviorSubject<ArrivalQcGeneration>(null);

  //observables
  arrivalQcGenerationData$ = this.arrivalQcGenerationDataSubject.asObservable();

  constructor() {}

  public updateArrivalQcGenerationData(data: ArrivalQcGeneration): void {
    this.arrivalQcGenerationDataSubject.next(data);
  }
}
